/*
 * Pastilles d'avertissement (hazmat / vente finale).
 * Sur écran tactile le survol n'existe pas : un appui sur la pastille ouvre
 * l'infobulle (classe .is-open, animée en scale via core.css), un appui à
 * l'extérieur ou sur Échap la referme. Sur desktop, le clic « épingle »
 * l'infobulle en plus du survol.
 */
(function () {
    function closeAll(except) {
        document.querySelectorAll('.warning-tooltip.is-open').forEach(function (tooltip) {
            if (tooltip !== except) tooltip.classList.remove('is-open');
        });
    }

    document.addEventListener('click', function (event) {
        // Bandeaux du panier : repliés sur une ligne en mobile (core.css),
        // un appui déplie/replie le message complet. Les liens restent cliquables.
        var banner = event.target.closest('.warning-banner');
        if (banner) {
            if (!event.target.closest('a')) banner.classList.toggle('is-open');
            return;
        }

        var trigger = event.target.closest('.warning-tooltip__trigger');
        if (trigger) {
            var tooltip = trigger.closest('.warning-tooltip');
            var isOpen = tooltip.classList.toggle('is-open');
            closeAll(isOpen ? tooltip : null);
            return;
        }
        // Un clic dans la bulle (ex. lien vers la politique) ne referme pas
        if (!event.target.closest('.warning-tooltip')) closeAll(null);
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeAll(null);
    });
})();
